import { render, staticRenderFns } from "./OnboardingMoral.vue?vue&type=template&id=43cb1510&scoped=true"
import script from "./OnboardingMoral.vue?vue&type=script&lang=js"
export * from "./OnboardingMoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cb1510",
  null
  
)

export default component.exports